/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
// @ts-expect-error Could not find a declaration file for module
import { getPageFromPathname } from '../selectors/routeSelectors';
// @ts-expect-error Could not find a declaration file for module
import { fetchPartnerTracks, fetchPublicTracks } from '../actions/TrackActions';
import ApiError from '../components/Errors/ApiError';
import NoResultsError from '../components/Errors/NoResultsError';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import { FILTER_CONSTS } from '../constants/TopFilterConstants';
import { fetchPartnerLessons, fetchPublicLessons
// @ts-expect-error Could not find a declaration file for module
} from '../actions/LessonActions';
import { useIsPartner } from '../features/partners';
// @ts-expect-error Could not find a declaration file for module
import PaginatedUICardGrid from '../containers/MyLearningPage/PaginatedUICardGrid';
// @ts-expect-error Could not find a declaration file for module
import MyLearningTopFilters from '../containers/MyLearningPage/MyLearningTopFilters';
import { safeSmoothScrollTo } from '../utils/utils';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useAllProgress } from '../features/userProgress';
import ReducedContentCard from '../components/ContentCards/ReducedContentCard/ReducedContentCard';
import { useSearchParamCatalogSearch } from '../features/search';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  STATUSES: STATUSES_KEYED
} = FILTER_CONSTS;
const useFetchRequirements = () => {
  const dispatch = useDispatch();
  const fetchRequirements = useCallback(isPartner => {
    dispatch(fetchPublicTracks());
    dispatch(fetchPublicLessons());
    if (isPartner) {
      dispatch(fetchPartnerTracks());
      dispatch(fetchPartnerLessons());
    }
  }, [dispatch]);
  return fetchRequirements;
};
export const MyLearningLegacy = ({
  updateTitleDetails,
  status = STATUSES_KEYED.IN_PROGRESS
}) => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const hasError = useSelector(state => state.tracks.get('hasError') || false);
  const {
    allProgressLoading
  } = useAllProgress();
  const isPartner = !!useIsPartner();
  const page = useSelector(state => getPageFromPathname(state, {
    match
  }) || 1);
  const recentError = useSelector(state => state.tracks.get('recentError'));
  const fetchRequirements = useFetchRequirements();
  const {
    tracksLessonsSearchQueryData,
    tracksLessonsSearchQueryLoading,
    tracksLessonsSearchQueryError
  } = useSearchParamCatalogSearch({
    isPartnerPage: false,
    sortByDefault: true,
    status: [status],
    context: 'INDIVIDUAL'
  });
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.MY_LEARNING
    });
    fetchRequirements(isPartner);
  }, [fetchRequirements, isPartner]);
  const previousSearchData = useRef(tracksLessonsSearchQueryData);
  useEffect(() => {
    if (previousSearchData.current && previousSearchData.current.length && !tracksLessonsSearchQueryData.length) {
      updateTitleDetails({
        endCard: 0,
        cardsTotal: 0,
        startCard: 0
      });
    }
    previousSearchData.current = tracksLessonsSearchQueryData;
  }, [tracksLessonsSearchQueryData, updateTitleDetails]);
  const handlePageChange = pageNumber => {
    history.push(Object.assign({}, location, {
      pathname: location.pathname.replace(/(\/page\/\d+)|$/, `/page/${pageNumber}`)
    }));
    safeSmoothScrollTo(window, 0, 0);
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "my-learning-page",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "MYLEARNING_LISTING_LOADED"
    }), /*#__PURE__*/_jsx(MyLearningTopFilters, {}), allProgressLoading || tracksLessonsSearchQueryLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true
    }) : hasError || tracksLessonsSearchQueryError ? /*#__PURE__*/_jsx(ApiError, {
      className: "tracks-api-error",
      error: recentError || tracksLessonsSearchQueryError,
      marker404: "MYLEARNING_LISTING_API_404",
      markerDefault: "MYLEARNING_LISTING_API_ERROR"
    }) : !tracksLessonsSearchQueryData.length ? /*#__PURE__*/_jsx(NoResultsError, {
      resetLink: location.pathname
    }) : /*#__PURE__*/_jsx(PaginatedUICardGrid, {
      limit: 12,
      onCalculateContents: updateTitleDetails,
      onPageChange: handlePageChange,
      page: page,
      children: tracksLessonsSearchQueryData.map((item, index) => {
        return /*#__PURE__*/_jsx(ReducedContentCard, {
          appearsIn: "filterable-results",
          contentId: Number(item.id),
          contentType: item.contentType === 'TRACK' ? 'track' : 'lesson',
          language: item.language || undefined,
          position: index + 1
        }, item.id);
      })
    })]
  });
};
export default MyLearningLegacy;